import { lazy } from "react"

export default [
    {
        path: "/skk",
        component: lazy(() => import("../../views/skk/SKKCheck")),
        layout: 'BlankLayout',
        meta: {
            authRoute: true
        }
    }
]